import React from "react";
import {DeliveryStatus} from "../../constants/DeliveryStatus";
import {FaCheck, FaTimes} from "react-icons/all";
import {IconContext} from "react-icons";
import {NotPresentAction} from "./NotTherePopUp";
import {Moment} from "moment";
import {RequestPayload} from "../sites/types/RequestPayload";
import {DeleteAtDatabaseService} from "../../services/database/DeleteAtDatabaseService";
import {UpdateAtDatabaseService} from "../../services/database/UpdateAtDatabaseService";

const moment = require("moment");

/**
 * React Component properties
 */
type Props = {
  // data
  estimatedTimeOfArrival: string;
  status: DeliveryStatus;
  searchResult: RequestPayload;
  trackingID: string;

  //
  onPressNotPresent: () => void;
};

/**
 * Rebders the different possible stati of the delivery
 *
 * @param deliveryTimePeriodStart
 * @param estimatedTimeOfArrival
 * @param currentStatus
 */
function renderStatus(
  deliveryTimePeriodStart: string,
  estimatedTimeOfArrival: string,
  currentStatus: DeliveryStatus
): JSX.Element {
  const eTA: Moment = moment(estimatedTimeOfArrival);
  const deliveryTimePeriodEnd: Moment = moment(deliveryTimePeriodStart).add(
    2,
    "hours"
  );
  let statusText: string = "";
  let statusColor: string = "";

  switch (currentStatus) {
    case DeliveryStatus.active:
      {
        if (eTA.isBefore(deliveryTimePeriodEnd)) {
          statusText = "In der Zustellung";
          statusColor = "#6BC963";
        } else {
          statusText = "Verspätet";
          statusColor = "#ffae00";
        }
      }
      break;
    case DeliveryStatus.canceled:
      statusText = "Storniert";
      statusColor = "#c93845";
      break;
    case DeliveryStatus.delivered:
      statusText = "Zugestellt";
      statusColor = "#6BC963";
      break;
    case DeliveryStatus.dropAllowed:
      statusText = "Abstellgenehmigung erteilt";
      statusColor = "#617dc9";
      break;
  }

  return (
    <div className={"status_container"} style={{ backgroundColor: statusColor }}>
      <h4>{statusText}</h4>
    </div>
  );
}

/**
 * Will be called when the user is present
 *
 * @param trackingID
 */
async function receiverIsPresent(trackingID: string) {

  await DeleteAtDatabaseService.removeNotPresentAction(trackingID);
  await UpdateAtDatabaseService.updateNotThereAction(trackingID);
}

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * This component is used to display the teaser data about the delivery
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 */
export function DeliveryFirstMetaInfo(props: Props) {
  const deliveryTimePeriodStart: Moment = moment(
    props.searchResult.deliveryTimePeriodStart
  );
  const deliveryTimePeriodEnd: Moment = moment(
    props.searchResult.deliveryTimePeriodStart
  ).add(2, "hours");

  return (
    <div className={"first_meta_info_container"}>
      <div className={"first_meta_info_status"}>
        <h3>Status:</h3>

        {renderStatus(
          props.searchResult.deliveryTimePeriodStart,
          props.estimatedTimeOfArrival,
          props.status
        )}
      </div>

      <div className={"first_meta_info_time"}>
        <h3>Zustellzeitraum:</h3>

        <h4>
          Zwischen {deliveryTimePeriodStart.get("hours")} -{" "}
          {deliveryTimePeriodEnd.get("hours")} Uhr
        </h4>
      </div>

      {!props.searchResult.isPresent &&
        !props.searchResult.chosenNotPresentOption && (
          <div className={"first_meta_info_present"}>
            <h3>Sind Sie da:</h3>
            <div className={"present_question_container"}>
              <div
                className={"present_question_yes"}
                onClick={() => receiverIsPresent(props.trackingID)}
              >
                <IconContext.Provider
                  value={{ color: "#fff", className: "icon" }}
                >
                  <FaCheck />
                </IconContext.Provider>

                <div>Ja</div>
              </div>

              <div
                className={"present_question_no"}
                onClick={() => props.onPressNotPresent()}
              >
                <IconContext.Provider
                  value={{ color: "#fff", className: "icon" }}
                >
                  <FaTimes />
                </IconContext.Provider>

                <div>Nein</div>
              </div>
            </div>
          </div>
        )}

      {!!props.searchResult.isPresent &&
        !props.searchResult.chosenNotPresentOption && (
          <div className={"first_meta_info_present"}>
            <h3>Sind Sie da:</h3>
            <div className={"present_question_container"}>
              <div className={"present_question_yes"}>
                <IconContext.Provider
                  value={{ color: "#fff", className: "icon" }}
                >
                  <FaCheck />
                </IconContext.Provider>

                <div>Anwesenheit bestätigt</div>
              </div>

              <div className={"button_container"}>
                <button onClick={() => props.onPressNotPresent()}>
                  Ändern
                </button>
              </div>
            </div>
          </div>
        )}

      {!props.searchResult.isPresent &&
        props.searchResult.chosenNotPresentOption ===
          NotPresentAction.NEIGHBOR_RELEASE && (
          <div className={"first_meta_info_present"}>
            <h3>Gewählte Zustelloption:</h3>
            <div className={"present_question_container"}>
              <div className={"present_question_yes"}>
                <IconContext.Provider
                  value={{ color: "#fff", className: "icon" }}
                >
                  <FaCheck />
                </IconContext.Provider>

                <div>Nachbar-Zustellung</div>
              </div>
            </div>
          </div>
        )}

      {!props.searchResult.isPresent &&
      props.searchResult.chosenNotPresentOption ===
      NotPresentAction.SIGNATURE_RELEASE_AUTHORISATION && (
          <div className={"first_meta_info_present"}>
            <h3>Gewählte Zustelloption:</h3>
            <div className={"present_question_container"}>
              <div className={"present_question_yes"}>
                <IconContext.Provider
                    value={{ color: "#fff", className: "icon" }}
                >
                  <FaCheck />
                </IconContext.Provider>

                <div>Abstellgenehmigung erteilt</div>
              </div>
            </div>
          </div>
      )}
    </div>
  );
}
